// extracted by mini-css-extract-plugin
module.exports = {"base":"SkeletonTable_base__3Izmd","row":"SkeletonTable_row__2PygN","col":"SkeletonTable_col__3jxxg"};